if (!customElements.get('unite-mail-motion')) {
  customElements.define('unite-mail-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const title = this.querySelector('[data-motion-title]');
      const animateTitle = () => {
      if (title) {
        const text = title.textContent;
        const visual = document.createElement('span');
        visual.setAttribute('aria-hidden', 'true');
        let count = 0;
        text.split(/(\s+)/).forEach(word => {
          if (/^\s+$/.test(word)) { visual.append(document.createTextNode(word)); return; }
          const group = document.createElement('span');
          group.className = 'unite-mail-stage__word';
          Array.from(word).forEach(letter => {
            const span = document.createElement('span');
            span.className = 'unite-mail-stage__letter';
            span.style.setProperty('--letter-delay', count++ * 30 + 'ms');
            span.textContent = letter;
            group.append(span);
          });
          visual.append(group);
        });
        title.setAttribute('aria-label', text);
        title.replaceChildren(visual);
      }
      };
      if (document.fonts?.ready) document.fonts.ready.then(() => { if (this.isConnected) animateTitle(); });
      else animateTitle();
      this.classList.add('is-ready');
      this.progress = window.scrollY > 2 ? 1 : 0;
      this.update = () => {
        this.style.setProperty('--mail-image-y', ((1 - this.progress) * 105) + '%');
        this.dataset.progress = this.progress.toFixed(3);
      };
      const consume = delta => {
        if (!this.classList.contains('has-image') || window.scrollY > 2) return false;
        if ((delta > 0 && this.progress < 1) || (delta < 0 && this.progress > 0)) {
          this.progress = Math.min(1, Math.max(0, this.progress + delta / innerHeight));
          this.update();
          return true;
        }
        return false;
      };
      const interactive = target => target instanceof Element && target.closest('input,textarea,select,[contenteditable],iframe,[role="dialog"]');
      this.onWheel = event => {
        if (event.ctrlKey || interactive(event.target) || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
        const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1);
        if (event.cancelable && consume(delta)) event.preventDefault();
      };
      this.onTouchStart = event => { this.touchY = event.touches.length === 1 ? event.touches[0].clientY : null; };
      this.onTouchMove = event => {
        if (this.touchY === null || event.touches.length !== 1 || interactive(event.target)) return;
        const y = event.touches[0].clientY;
        if (event.cancelable && consume(this.touchY - y)) event.preventDefault();
        this.touchY = y;
      };
      this.onKey = event => {
        if (interactive(event.target) || event.target.closest?.('button,a') || event.altKey || event.ctrlKey || event.metaKey) return;
        const deltas = {ArrowDown: 60, ArrowUp: -60, PageDown: innerHeight * .85, PageUp: -innerHeight * .85, ' ': innerHeight * (event.shiftKey ? -.85 : .85)};
        if (deltas[event.key] && consume(deltas[event.key])) event.preventDefault();
      };
      this.onScroll = () => {
        if (window.scrollY > 2) this.progress = 1;
        this.update();
      };
      addEventListener('wheel', this.onWheel, {passive:false});
      addEventListener('touchstart', this.onTouchStart, {passive:true});
      addEventListener('touchmove', this.onTouchMove, {passive:false});
      addEventListener('keydown', this.onKey);
      addEventListener('scroll', this.onScroll, {passive:true});
      addEventListener('resize', this.onScroll, {passive:true});
      this.update();
    }
    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
      removeEventListener('wheel', this.onWheel);
      removeEventListener('touchstart', this.onTouchStart);
      removeEventListener('touchmove', this.onTouchMove);
      removeEventListener('keydown', this.onKey);
      this.ready = false;
    }
  });
}
document.querySelectorAll('.u-mail-film').forEach(film => {
  const video = film.querySelector('video');
  if (!video || film.dataset.ready) return;
  film.dataset.ready = 'true';
  const button = film.querySelector('button');
  button?.addEventListener('click', () => video.paused ? video.play().catch(() => {}) : video.pause());
  const sync = () => {
    if (!button) return;
    button.textContent = video.paused ? '▷' : 'Ⅱ';
    button.setAttribute('aria-label', video.paused ? 'Reproducir video' : 'Pausar video');
  };
  video.addEventListener('play', sync);
  video.addEventListener('pause', sync);
  new IntersectionObserver(([entry]) => entry.isIntersecting ? video.play().catch(() => {}) : video.pause(), {threshold:.2}).observe(video);
  sync();
});
